import Model from './Model'

export default class ProjectWebsiteModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'projectWebsites'
  }
}
